import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const EVENTS_SERVICE_TOKEN = new InjectionToken<IEventsService>('IEventsService');

export interface IEventsService {
  /**
   * Subscribe on event bus by key
   */
  on<T>(key): Observable<T>;

  /**
   * Send event data to chanel by key
   */
  broadcast(key: string, data?: any);
}
